import type { FaireProductEntity } from "../../entity_types/product";

export const p_4q9t43a45q: FaireProductEntity = {
  token: "p_4q9t43a45q",
  type: "product",
  name: "Tomato Enamel Keychain & Bag Charm",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/827625b30c8350d76be59d2319cf9388e6c091f7a5ed93cd1769a52109a744da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d147513725c97cadfa68740e576cb52f2ffe06c6eb7dc1c3cc3c46a5d35e6887.jpeg",
    "https://cdn.faire.com/fastly/39988a15cce5aebd73301b521ec3c8a53c32fe69ae6c49d7e5a2b05cbc33aec2.jpeg"
  ],
  priceDollars: 8,
  description: "This cheerful mini tomato adds a pop of color and a dash of whimsy to your keys, purse, or bag. Perfect for foodies, chefs, and anyone who loves design-forward, playful accessories. Makes a cute gift or personal treat for yourself.\n\nMakes a fun gift or a personal treat for yourself!\n\n𝐆𝐨𝐨𝐝 𝐭𝐨 𝐤𝐧𝐨𝐰:\n\n• Soft enamel keychain/bag charm\n• Keyring with lobster clasp\n• Measures approximately 2” (backing card is roughly 3\"x2\")\n• Designed in Portland, Maine by Mel Andrel",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:01.317Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
